import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F3B35",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M4.5 12H18M15 7.5l4.5 4.5-4.5 4.5"
    }, null, -1)
  ])))
}
export default { render: render }